// extracted by mini-css-extract-plugin
export default {"vertical":"onfido-sdk-ui-ActiveVideo-ConnectionError-vertical"};